<!-- 企业级-无人仓业务-配置设置 -->
<template>
  <div class="mainArea CConfigSetting">
      
        <div class="searchDiv mt20">
          <div>
            <div class="dib"><el-input placeholder="请输入设备ID" v-model="keyword.device_id" clearable></el-input></div>
            <div class="dib"><el-input placeholder="请输入设备名称" v-model="keyword.device_name" clearable></el-input></div>
            <!-- <div class="dib"><el-input placeholder="请输入子库" v-model="keyword.device_address" clearable></el-input></div> -->
            <el-button type="primary" @click="getWarehouse(1)">搜索</el-button>
          </div>
        </div>
        <el-button type="primary" class="mb20 mt20" @click="openAdd">添加</el-button>
        <div class="tabList">
          <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="about_data" label="设备ID"></el-table-column>
            <el-table-column prop="original_data" label="子库"></el-table-column>
            <!-- <el-table-column prop="" label="企业token值"></el-table-column> -->
            <el-table-column prop="desc" label="备注"></el-table-column>
            <el-table-column label="入库二维码">
              <template slot-scope="scope">
                <el-button type="text" @click="previewImg(scope.row.pickupQrcode)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column label="出库二维码">
              <template slot-scope="scope">
                <el-button type="text" @click="previewImg(scope.row.replenishQrcode)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="openEdit(scope.$index)">修改</el-button>
                <el-button type="text" @click="openStatus(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="total>page">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="page"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      <!--添加配置-->
      <el-dialog title="添加" :visible.sync="addConfigDio" width="480px">
        <div class="contDio">
          <el-form ref="form" :rules="rules" :model="addform" label-width="90px">
            <el-form-item label="所属空间:" prop="space_id">
              <el-cascader
                class="db"
                :options="spaceList"
                v-model="addform.space_id"
                change-on-select
                :props="selectProps" 
                @change="getSpaceDeviceTypeList(addform.space_id[addform.space_id.length-1])">
              </el-cascader>
            </el-form-item>
            <el-form-item label="设备名称:" prop="device_id">
              <el-select v-model="addform.device_id" placeholder="请选择设备名称">
                <el-option
                  v-for="item in deviceList"
                  :key="item.device_no_id"
                  :label="item.device_name"
                  :value="item.device_no_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备ID:">
              {{addform.device_id}}
            </el-form-item>
            <el-form-item label="子库:" prop="original_data">
              <el-input placeholder="请输入子库" v-model="addform.original_data"></el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="addform.desc"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addConfig('form')">确定</el-button>
          <el-button @click="addConfigDio = false">取消</el-button>
        </span>
      </el-dialog>
      <!--修改配置-->
      <el-dialog title="修改" :visible.sync="editConfigDio" width="480px">
        <div class="contDio">
          <el-form ref="form2" :rules="rules2" :model="editform" label-width="90px">
            <el-form-item label="所属空间:" prop="space_id">
              <el-cascader
                class="db"
                :options="spaceList"
                v-model="editform.space_id"
                change-on-select
                :props="selectProps" 
                @change="getSpaceDeviceTypeList(editform.space_id[editform.space_id.length-1],2)">
              </el-cascader>
            </el-form-item>
            <el-form-item label="设备名称:" prop="device_id">
              <el-select v-model="editform.device_id" placeholder="请选择设备名称">
                <el-option
                  v-for="item in deviceList"
                  :key="item.device_no_id"
                  :label="item.device_name"
                  :value="item.device_no_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备ID:">
              {{editform.device_id}}
            </el-form-item>
            <el-form-item label="子库:" prop="original_data">
              <el-input placeholder="请输入子库" v-model="editform.original_data"></el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="editform.desc"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="editConfig('form2')">确定</el-button>
          <el-button @click="editConfigDio = false">取消</el-button>
        </span>
      </el-dialog>
      <!--预览二维码-->
      <el-dialog title="" :visible.sync="previewDio" class="previewDio" width="350px">
        <div class="tr"><el-button v-print="'#ewm'">打印</el-button></div>
        <div class="img" id="ewm"><img :src="dioImageUrl" alt=""></div>
      </el-dialog>

      <!--删除配置-->
      <el-dialog title="" :visible.sync="statusDio" class="statusDio">
        <div class="statusCont">
          <div>是否删除该配置？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="statusDio = false">取 消</el-button>
          <el-button type="primary" @click="delConfig">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../static/js/utility/utility.js"
  import { unmanApi,eSiteApi,sceneApi } from "../../../../static/js/api.js"

  export default {
    name: 'CConfigSetting',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          device_id:'',
          device_address:'',
          device_name:'',
        },

        configList:[],//配置列表
        tableLoading:false,
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        addConfigDio:false,//添加弹窗
        addform:{
          device_id:'',
          original_data:'',
          desc:'',
          device_name:'',
          space_id:[],
        },
        rules:{
          space_id:[
            { required: true, message: '请选择空间', trigger: 'blur' },
          ],
          device_id:[
            { required: true, message: '请选择设备名称', trigger: 'blur' },
          ],
          original_data:[
            { required: true, message: '请输入子库', trigger: 'blur' },
          ]
        },

        editConfigDio:false,//修改弹窗
        editform:{
          device_id:'',
          original_data:'',
          desc:'',
          device_name:'',
          space_id:[],
        },
        rules2:{
          space_id:[
            { required: true, message: '请选择空间', trigger: 'blur' },
          ],
          device_id:[
            { required: true, message: '请选择设备名称', trigger: 'blur' },
          ],
          original_data:[
            { required: true, message: '请输入子库', trigger: 'blur' },
          ]
        },
        spaceList:[],//空间列表
        deviceList:[],//设备列表
        // 级联选择器配置
        selectProps: {
          label: 'space_name',
          value: 'space_id',
          children: 'children'
        },
        
        previewDio:false,//预览二维码
        dioImageUrl:'',//二维码地址

        statusDio:false,
        del_id:'',
      };
    },
    mounted(){

    },
    created: async function () {
      this.getWarehouse()
    },
    methods: {
      //打开删除弹窗
      openStatus(index){
        this.del_id = this.configList[index].parameter_about_id
        this.statusDio = true;
      },
      //删除授权用户
      async delConfig(){
        let that = this;
        let data = {
          'id': that.del_id,//授权用户id
        }
        let res = await unmanApi.deleteConfig(data)
        if (res.meta.code === 200) {
          that.getWarehouse(1)
          that.statusDio = false;
          showToast('删除成功！')
        } else {
          showToast(res.meta.message)
        }
      },
      //查看二维码
      previewImg(img){
        this.dioImageUrl = img
        this.previewDio = true
      },
      //修改配置
      editConfig(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.submitConfig(that.editform.id)
          } else {
            return false;
          }
        });
      },
      //打开修改配置
      openEdit(index){
        this.spaceList=[]
        this.deviceList=[]
        this.editform.id = this.configList[index].parameter_about_id
        this.editform.device_id = this.configList[index].about_data
        this.editform.device_name = this.configList[index].device_name
        this.editform.original_data = this.configList[index].original_data
        this.editform.desc = this.configList[index].desc
        this.getSpaceList();
        this.getSpaceDeviceTypeList(this.configList[index].space_id,2)
        this.getSpaceParentSpace(index);
        this.editConfigDio = true;
      },
      //获取空间父id
      async getSpaceParentSpace(index){
        let that = this
        const data = {
          'space_id':that.configList[index].space_id
        }
        let res = await unmanApi.getSpaceParentSpace(data)
        if (res.meta.code === 200) {
          that.editform.space_id = res.data.space_str.split(',')
        } else {
          showToast(res.meta.message)
        }
      },
      //添加配置
      addConfig(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.submitConfig()
          } else {
            return false;
          }
        });
      },
      //提交配置
      async submitConfig(id){
        let that = this
        if(id){
          var data = {
            'original_data': that.editform.original_data,//子库
            'device_id': that.editform.device_id,//设备ID
            'desc': that.editform.desc,//备注
            'id': id
          }
        }else{
          var data = {
            'original_data': that.addform.original_data,//子库
            'device_id': that.addform.device_id,//设备ID
            'desc': that.addform.desc,//备注
          }
        }
        let res = await unmanApi.updateConfig(data)
        if(res.meta.code == 200){
          if(!id){
            that.addform = {
              device_id:'',
              original_data:'',
              desc:''
            }
            that.spaceList=[]
            that.deviceList=[]
            that.addConfigDio = false
            that.getWarehouse(1)
            showToast('添加成功！')
          }else{
            that.editConfigDio = false
            that.getWarehouse()
            showToast('修改成功！')
          }
          
        }else{
          showToast(res.meta.message)
        }
      },
      //打开添加弹窗
      openAdd(){
        this.spaceList=[]
        this.deviceList=[]
        this.getSpaceList();
        this.addConfigDio = true;
      },
      //获取空间列表
      async getSpaceList(){
        let that = this
        let res = await sceneApi.space()
        if (res.meta.code === 200) {
          that.processScene(res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理位置数据
      processScene(data) {
        let that = this
        if ( data.length !== 0) {
          // 显示某个公司或其下级空间的设备列表
          let list = data
          // 获取所属位置列表
          for (let s in list) {
            let area =  list[s].children
              // console.log('area', area, list[s].space_name)
            for (let i in area) {
              let street = area[i].children
              // console.log('street', street, area[i].space_name)
              for (let j in street) {
                let company = street[j]
                // console.log('company', company, company.space_name )
                that.spaceList.push(company)
              }
            }
          }
          // console.log(that.spaceList)
        }

      },
      //获取设备类型列表
      async getSpaceDeviceTypeList(space_id,type){
        let that = this;
        const data = {
          'space_id': space_id,
          'code': 'WAREHOUSE'
        }
        let res = await unmanApi.getSpaceDeviceTypeList(data)
        if(res.meta.code == 200){
          that.addform.device_id =''
          if(type == 2){
            const obj = {
              'device_name':that.editform.device_name,
              'device_no_id':that.editform.device_id
            }
            res.data.splice(0,0,obj)
          }
          that.deviceList = res.data
        }else{
          showToast(res.meta.message)
        }
      },
      //获取配置设置列表
      async getWarehouse(curr,limits){
        let that = this;
        this.tableLoading = true
        const data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
          // 'location': that.keyword.device_address,//设备所在地址
          'device_id': that.keyword.device_id,//设备id
          'device_name': that.keyword.device_name,//设备名称
        }
        let res = await unmanApi.getWarehouse(data)
        if(res.meta.code == 200){
          that.configList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getWarehouse(val)
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
      
    }
  }
</script>

<style lang="scss">
.CConfigSetting{
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
  
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  .contDio{
    .el-select{ display:block;}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CUnmanWarehouse/CConfigSetting.vue